import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button } from '../../../../components';
import ProfileIconCard from '../../../../components/ProfileIconCard/ProfileIconCard';
import { FormattedMessage } from '../../../../util/reactIntl';
import { createResourceLocatorString } from '../../../../util/routes';
import css from './JoinedGroups.module.css';
import { subscriptionPermissionRequest } from '../../../../ducks/user.duck';

const SORT_ORDER_KEY = 'joinedGroupsSortOrder';

const JoinedGroups = props => {
  const [isOpen, setIsOpen] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const [sortOrder, setSortOrder] = useState(() => {
    // Initialize from sessionStorage if available
    if (typeof window !== 'undefined') {
      return sessionStorage.getItem(SORT_ORDER_KEY) || 'asc';
    }
    return 'asc';
  });
  const dispatch = useDispatch();
  const {
    spaceListData = [],
    history,
    routeConfiguration,
    activeIndexId,
    isRequestSpace,
    onRequestGroupClick,
    requestNewSpace,
    onSetActiveTab,
    checkCreatePostAuth,
    userModeratorsGroups,
  } = props;

  const isMyGroups = Array.isArray(spaceListData)
    ? spaceListData.filter(item => {
      const isModerator = Array.isArray(userModeratorsGroups) &&
        userModeratorsGroups.some(st => st.status == "active" && st.groupId == item.id);
      const canManage = item.is_member
      return (!isModerator) && canManage;
    })
    : [];

  if (isMyGroups.length == 0) return null;


  const toggleVisibility = () => {
    setIsOpen(!isOpen);
  };

  const fetchSpaceDetails = space => {
    const { id, slug } = space;
    onSetActiveTab('')
    return history.push(
      createResourceLocatorString('JoinedGroupsCommunityPage', routeConfiguration, { id, slug }, {})
    );
    // dispatch(getSpaceDetails({ spaceId }));
    // setIsFeedRequested();
  };

  const disableBodyScroll = () => {
    const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.overflow = 'hidden';
    document.body.style.paddingRight = `${scrollBarWidth + 1}px`; // Preserve scrollbar space
  };

  const enableBodyScroll = () => {
    document.body.style.overflow = '';
    document.body.style.paddingRight = ''; // Reset padding
  };

  return (
    <>
      <div  className={css.accordionHeading}>
        <div className={css.accordionTitle}>
          <FormattedMessage id='SpaceGroups.myGroups' />
          <div className={css.sortButtonWrapper}>
            <button
              className={css.sortButton}
              onClick={() => {
                const newOrder = sortOrder === 'asc' ? 'desc' : 'asc';
                setSortOrder(newOrder);
                sessionStorage.setItem(SORT_ORDER_KEY, newOrder);
              }}
            >
              {sortOrder === 'asc' ? 'A-Z' : 'Z-A'}
                 <ProfileIconCard type="sort" />
            </button>
          </div>
        </div>{' '}
        <span onClick={toggleVisibility} className={css.arrows}>{isOpen ? '-' : '+'}</span>

      </div>
      <div className={css.searchWrapper}>
              <input
                type="text"
                className={css.searchInput}
                placeholder="Search for groups"
                value={searchQuery}
                onChange={e => setSearchQuery(e.target.value)}
              />
            </div>
      {isOpen && (
        <>

          <div
            className={css.accordionData}
            // onMouseEnter={disableBodyScroll}
            // onMouseLeave={enableBodyScroll}
          >
            {Array.isArray(isMyGroups)
              ? (() => {
                  const filteredGroups = isMyGroups
                    .filter(item => (item.name || '').toLowerCase().includes(searchQuery.toLowerCase()))
                    .sort((a, b) => sortOrder === 'asc'
                      ? a.name.localeCompare(b.name)
                      : b.name.localeCompare(a.name)
                    );
                  
                  if (searchQuery.trim() && filteredGroups.length === 0) {
                    return (
                      <div className={css.noResultMessage}>
                        <FormattedMessage id="MobileHamburgerNavigation.NO_GROUPS_FOUND" defaultMessage="No groups found" />
                      </div>
                    );
                  }
                  
                  return filteredGroups.map(item => (
                    <div
                      className={css.spaceItems}
                      key={item.id}
                      onClick={() => fetchSpaceDetails(item)}
                    >
                      <ProfileIconCard type="orange" />
                      {/* higlight the selected item*/}
                      <span className={item.id == activeIndexId ? css.boldText : ''}>
                        {item.name}
                      </span>
                    </div>
                  ));
                })()
              : null}
          </div>
        </>
      )}
      <div className={css.spacer}></div>
    </>
  );
};

export default JoinedGroups;
